import { BusyIndicator, BusyIndicatorPropTypes } from '@sba/design-system';
import classNames from 'classnames';
import React from 'react';
import styles from './LoadingArea.module.css';

const spinnerIcon = (size = 32) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width={size} height={size} className={styles.spinner}>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(0 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0" />
    </path>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(45 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.125s" />
    </path>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(90 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.25s" />
    </path>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(135 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.375s" />
    </path>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(180 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.5s" />
    </path>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(225 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.625s" />
    </path>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(270 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.75s" />
    </path>
    <path opacity=".1" d="M14 0 H18 V8 H14 z" transform="rotate(315 16 16)">
      <animate attributeName="opacity" from="1" to=".1" dur="1s" repeatCount="indefinite" begin="0.875s" />
    </path>
  </svg>
);

interface SpinnerProps {
  size?: number;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 32 }) => spinnerIcon(size);

const classNamesByPadding = {
  padding: styles.padding,
  noPadding: styles.noPadding,
};

interface LoadingAreaProps {
  padding?: 'padding' | 'noPadding';
  className?: string;
  size?: BusyIndicatorPropTypes['size'];
  delay?: number;
}

function LoadingArea({ padding = 'padding', className, size = 'M', delay = 100 }: LoadingAreaProps) {
  return (
    <div data-testid="loadingArea" className={classNames(styles.area, classNamesByPadding[padding], className)}>
      <BusyIndicator active size={size} delay={delay} />
    </div>
  );
}

export default LoadingArea;
